import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full min-w-0" }
const _hoisted_2 = { class: "hidden lg:block w-full min-w-0" }
const _hoisted_3 = { class: "overflow-x-auto overscroll-x-contain border-t border-slate-100" }
const _hoisted_4 = { class: "w-full min-w-[64rem] border-separate border-spacing-0 text-left" }
const _hoisted_5 = { class: "sticky top-0 z-20 shadow-[0_1px_0_0_rgb(0_0_0/0.08)]" }
const _hoisted_6 = { class: "flex items-center gap-1.5" }
const _hoisted_7 = {
  class: "w-3.5 h-3.5 shrink-0 text-slate-500",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = { class: "flex items-center gap-1.5" }
const _hoisted_10 = {
  class: "w-3.5 h-3.5 shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_11 = ["d"]
const _hoisted_12 = { class: "flex items-center gap-1.5" }
const _hoisted_13 = {
  class: "w-3.5 h-3.5 shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = ["d"]
const _hoisted_15 = { class: "flex items-center gap-1.5" }
const _hoisted_16 = {
  class: "w-3.5 h-3.5 shrink-0",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = ["d"]
const _hoisted_18 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_19 = { class: "px-3 py-2.5 align-middle" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "px-3 py-2.5 align-top min-w-0" }
const _hoisted_22 = { class: "font-semibold text-slate-900 text-sm leading-snug line-clamp-2" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "px-3 py-2.5 text-slate-600 align-top text-sm" }
const _hoisted_25 = { class: "px-3 py-2.5 align-top" }
const _hoisted_26 = {
  key: 1,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500"
}
const _hoisted_27 = { class: "px-3 py-2.5 align-top tabular-nums text-sm font-bold text-slate-900" }
const _hoisted_28 = { class: "px-3 py-2.5 align-top max-w-[10rem]" }
const _hoisted_29 = ["title"]
const _hoisted_30 = {
  key: 1,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500"
}
const _hoisted_31 = { class: "px-3 py-2.5 align-top min-w-0 max-w-[12rem]" }
const _hoisted_32 = { class: "flex items-start gap-1.5 text-slate-700 min-w-0" }
const _hoisted_33 = {
  class: "w-4 h-4 shrink-0 mt-0.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_34 = ["d"]
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "px-3 py-2.5 text-xs text-slate-600 align-top whitespace-nowrap" }
const _hoisted_37 = { class: "px-2 py-2 align-middle" }
const _hoisted_38 = { class: "inline-flex flex-wrap items-center justify-end gap-0.5" }
const _hoisted_39 = ["onClick", "disabled"]
const _hoisted_40 = ["onClick", "disabled"]
const _hoisted_41 = ["onClick", "disabled"]
const _hoisted_42 = { class: "mt-4 lg:hidden space-y-4 px-1 sm:px-2 pb-3" }
const _hoisted_43 = { class: "bg-gradient-to-r from-slate-50 to-slate-100 px-4 py-3 border-b border-slate-200" }
const _hoisted_44 = { class: "flex items-start justify-between gap-3" }
const _hoisted_45 = { class: "flex items-start gap-3 flex-1 min-w-0" }
const _hoisted_46 = { class: "flex-1 min-w-0" }
const _hoisted_47 = { class: "font-bold text-slate-900 text-base" }
const _hoisted_48 = { class: "text-xs text-slate-500 mt-1" }
const _hoisted_49 = { class: "px-4 py-3 space-y-3" }
const _hoisted_50 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_51 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_52 = { class: "text-lg font-bold text-slate-900 mt-1" }
const _hoisted_53 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_54 = { class: "flex items-center gap-1.5 mt-1" }
const _hoisted_55 = {
  class: "w-4 h-4 text-slate-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_56 = ["d"]
const _hoisted_57 = { class: "text-sm font-medium text-slate-800" }
const _hoisted_58 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_59 = {
  key: 1,
  class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1 bg-gray-100 text-gray-500"
}
const _hoisted_60 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_61 = {
  key: 1,
  class: "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1 bg-gray-100 text-gray-500"
}
const _hoisted_62 = { class: "bg-slate-50 rounded-lg px-3 py-2" }
const _hoisted_63 = { class: "text-sm text-slate-700 mt-1" }
const _hoisted_64 = { class: "text-sm text-slate-700" }
const _hoisted_65 = { class: "flex items-center justify-between py-2 px-3 bg-slate-50 rounded-lg" }
const _hoisted_66 = { class: "text-sm text-slate-700 font-medium" }
const _hoisted_67 = { class: "flex gap-2 pt-2" }
const _hoisted_68 = ["onClick", "disabled"]
const _hoisted_69 = ["onClick", "disabled"]
const _hoisted_70 = ["onClick", "disabled"]

import { ref, watch, computed } from "vue";
import { Pedido } from "../../interfaces/gpedPedido.inteface";

interface Props {
  pedidos: Pedido[];
  sortField: string | null;
  sortDirection: "asc" | "desc";
  isDelete?: boolean;
  accionEnProceso?: boolean;
  accionPedidoId?: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'pedidosPagadosTable',
  props: {
    pedidos: {},
    sortField: {},
    sortDirection: {},
    isDelete: { type: Boolean },
    accionEnProceso: { type: Boolean, default: false },
    accionPedidoId: { default: null }
  },
  emits: ["sort", "viewDetails", "updateEstado", "descargar-pdf"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showDeleteModal = ref(false);
const pedidoToDelete = ref<{ id: string; cliente: string } | null>(null);
const isDeleting = ref(false);

const tablaBloqueada = computed(
  () => props.accionEnProceso || isDeleting.value,
);

const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const formatCurrency = (value: string) =>
  new Intl.NumberFormat("es-PE", {
    style: "currency",
    currency: "PEN",
  }).format(parseFloat(value));

const getEstadoClass = (estado: string) => {
  const estados: Record<string, string> = {
    Pendiente: "bg-yellow-100 text-yellow-800",
    Pagado: "bg-emerald-100 text-emerald-800",
    "En Proceso": "bg-blue-100 text-blue-700",
    Completado: "bg-green-100 text-green-800",
    Cancelado: "bg-red-100 text-red-700",
    Rechazado: "bg-red-100 text-red-800",
    Entregado: "bg-purple-100 text-purple-700",
  };
  return estados[estado] || "bg-slate-100 text-slate-700";
};

const getMetodoPagoIcon = (metodo: string) => {
  if (metodo.toLowerCase().includes("efectivo")) {
    return "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z";
  } else if (
    metodo.toLowerCase().includes("tarjeta") ||
    metodo.toLowerCase().includes("visa") ||
    metodo.toLowerCase().includes("mastercard")
  ) {
    return "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z";
  } else if (metodo.toLowerCase().includes("transferencia")) {
    return "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4";
  }
  return "M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z";
};

const openDeleteModal = (id: string, cliente: string) => {
  pedidoToDelete.value = { id, cliente };
  showDeleteModal.value = true;
};

const handleUpdateEstado = (pedidoId: string) => {
  emit("updateEstado", pedidoId);
};

watch(
  () => props.isDelete,
  (newVal) => {
    if (newVal) {
      showDeleteModal.value = false;
      pedidoToDelete.value = null;
      isDeleting.value = false;
    }
  },
);

const getSortIcon = (field: string) => {
  if (props.sortField !== field) {
    return "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4";
  }
  return props.sortDirection === "asc"
    ? "M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"
    : "M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", _hoisted_5, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sort', 'estadoPedido'))),
                class: "w-32 px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer bg-slate-50 hover:bg-slate-200/80 transition-colors"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "Estado", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getSortIcon('estadoPedido')
                    }, null, 8, _hoisted_8)
                  ]))
                ])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("th", { class: "min-w-[11rem] px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Cliente ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("th", { class: "w-28 px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Doc. ", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("th", { class: "w-32 px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Comprob. ", -1)),
              _createElementVNode("th", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('sort', 'totalPedido'))),
                class: "w-28 px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer bg-slate-50 hover:bg-slate-200/80 transition-colors"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "Total", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getSortIcon('totalPedido')
                    }, null, 8, _hoisted_11)
                  ]))
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("th", { class: "min-w-[8.5rem] px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " M. compra ", -1)),
              _createElementVNode("th", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('sort', 'metodoPago'))),
                class: "min-w-[8.5rem] px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer bg-slate-50 hover:bg-slate-200/80 transition-colors"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "M. pago", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getSortIcon('metodoPago')
                    }, null, 8, _hoisted_14)
                  ]))
                ])
              ]),
              _createElementVNode("th", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('sort', 'createdAt'))),
                class: "min-w-[8rem] px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase cursor-pointer bg-slate-50 hover:bg-slate-200/80 transition-colors"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, "Fecha", -1)),
                  (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getSortIcon('createdAt')
                    }, null, 8, _hoisted_17)
                  ]))
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("th", { class: "w-40 px-3 py-3 text-left text-xs font-bold text-slate-700 uppercase bg-slate-50" }, " Acciones ", -1))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pedidos, (pedido) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: pedido.id,
                class: "hover:bg-slate-50/80 transition-colors"
              }, [
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-flex max-w-full items-center px-2.5 py-0.5 rounded-full text-xs font-semibold truncate", getEstadoClass(pedido.estadoPedido?.nombre || '')]),
                    title: pedido.estadoPedido?.nombre
                  }, _toDisplayString(pedido.estadoPedido?.nombre || "—"), 11, _hoisted_20)
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(pedido.cliente.nombreCliente) + " " + _toDisplayString(pedido.cliente.apellidoCliente), 1),
                  _createElementVNode("div", {
                    class: "text-xs text-slate-500 mt-0.5 truncate",
                    title: pedido.cliente.correoCliente
                  }, _toDisplayString(pedido.cliente.correoCliente), 9, _hoisted_23)
                ]),
                _createElementVNode("td", _hoisted_24, _toDisplayString(pedido.cliente.nroDocumento), 1),
                _createElementVNode("td", _hoisted_25, [
                  (pedido.tipoComprobante)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["inline-flex max-w-full items-center px-2 py-0.5 rounded-full text-xs font-medium truncate", 
                  pedido.tipoComprobante === 'Factura'
                    ? 'bg-blue-100 text-blue-700'
                    : 'bg-green-100 text-green-700'
                ])
                      }, _toDisplayString(pedido.tipoComprobante), 3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, " N/A "))
                ]),
                _createElementVNode("td", _hoisted_27, _toDisplayString(formatCurrency(pedido.totalPedido)), 1),
                _createElementVNode("td", _hoisted_28, [
                  (pedido.metodoCompra)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["inline-flex max-w-full items-center px-2 py-0.5 rounded-full text-xs font-medium line-clamp-2", 
                  pedido.metodoCompra === 'Entrega a Domicilio'
                    ? 'bg-indigo-100 text-indigo-700'
                    : 'bg-teal-100 text-teal-700'
                ]),
                        title: pedido.metodoCompra
                      }, _toDisplayString(pedido.metodoCompra), 11, _hoisted_29))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, " N/A "))
                ]),
                _createElementVNode("td", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_33, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: getMetodoPagoIcon(pedido.metodoPago.nombre)
                      }, null, 8, _hoisted_34)
                    ])),
                    _createElementVNode("span", {
                      class: "text-xs font-medium leading-snug line-clamp-2 break-words",
                      title: pedido.metodoPago.nombre
                    }, _toDisplayString(pedido.metodoPago.nombre), 9, _hoisted_35)
                  ])
                ]),
                _createElementVNode("td", _hoisted_36, _toDisplayString(formatDate(pedido.createdAt)), 1),
                _createElementVNode("td", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (emit('viewDetails', pedido.id)),
                      disabled: tablaBloqueada.value,
                      class: "p-2 text-green-600 hover:bg-green-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Ver detalles"
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("svg", {
                        class: "w-5 h-5",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        })
                      ], -1)
                    ]))], 8, _hoisted_39),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (handleUpdateEstado(pedido.id)),
                      disabled: tablaBloqueada.value,
                      class: "p-2 text-emerald-700 hover:bg-emerald-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Marcar como Completado"
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["w-5 h-5", {
                    'animate-spin':
                      __props.accionEnProceso && __props.accionPedidoId === pedido.id,
                  }]),
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        }, null, -1)
                      ]))], 2))
                    ], 8, _hoisted_40),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.$emit('descargar-pdf', pedido.id)),
                      disabled: tablaBloqueada.value,
                      class: "p-2 text-amber-700 hover:bg-amber-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                      title: "Descargar PDF"
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("svg", {
                        class: "w-4 h-4",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                        })
                      ], -1)
                    ]))], 8, _hoisted_41)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pedidos, (pedido) => {
        return (_openBlock(), _createElementBlock("div", {
          key: pedido.id,
          class: "bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition-shadow"
        }, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("h3", _hoisted_47, _toDisplayString(pedido.cliente.nombreCliente) + " " + _toDisplayString(pedido.cliente.apellidoCliente), 1),
                  _createElementVNode("p", _hoisted_48, _toDisplayString(pedido.cliente.nroDocumento), 1)
                ])
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center shrink-0 px-2.5 py-1 rounded-full text-xs font-semibold", getEstadoClass(pedido.estadoPedido?.nombre || '')])
              }, _toDisplayString(pedido.estadoPedido?.nombre || "—"), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Total", -1)),
                _createElementVNode("p", _hoisted_52, _toDisplayString(formatCurrency(pedido.totalPedido)), 1)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Pago", -1)),
                _createElementVNode("div", _hoisted_54, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_55, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: getMetodoPagoIcon(pedido.metodoPago.nombre)
                    }, null, 8, _hoisted_56)
                  ])),
                  _createElementVNode("p", _hoisted_57, _toDisplayString(pedido.metodoPago.nombre), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Comprobante", -1)),
              (pedido.tipoComprobante)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1", 
                pedido.tipoComprobante === 'Factura'
                  ? 'bg-blue-100 text-blue-700'
                  : 'bg-green-100 text-green-700'
              ])
                  }, _toDisplayString(pedido.tipoComprobante), 3))
                : (_openBlock(), _createElementBlock("span", _hoisted_59, " N/A "))
            ]),
            _createElementVNode("div", _hoisted_60, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Método de Compra", -1)),
              (pedido.metodoCompra)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-full text-xs font-medium mt-1", 
                pedido.metodoCompra === 'Entrega a Domicilio'
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'bg-teal-100 text-teal-700'
              ])
                  }, _toDisplayString(pedido.metodoCompra), 3))
                : (_openBlock(), _createElementBlock("span", _hoisted_61, " N/A "))
            ]),
            _createElementVNode("div", _hoisted_62, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase block" }, "Contacto", -1)),
              _createElementVNode("p", _hoisted_63, _toDisplayString(pedido.cliente.correoCliente), 1),
              _createElementVNode("p", _hoisted_64, _toDisplayString(pedido.cliente.telefono), 1)
            ]),
            _createElementVNode("div", _hoisted_65, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-xs font-semibold text-slate-500 uppercase" }, "Fecha", -1)),
              _createElementVNode("span", _hoisted_66, _toDisplayString(formatDate(pedido.createdAt)), 1)
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("button", {
                onClick: ($event: any) => (emit('viewDetails', pedido.id)),
                disabled: tablaBloqueada.value,
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, [...(_cache[22] || (_cache[22] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  }),
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  })
                ], -1),
                _createTextVNode(" Ver ", -1)
              ]))], 8, _hoisted_68),
              _createElementVNode("button", {
                onClick: ($event: any) => (handleUpdateEstado(pedido.id)),
                disabled: tablaBloqueada.value,
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-emerald-50 text-emerald-800 rounded-lg hover:bg-emerald-100 transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["w-4 h-4", {
                  'animate-spin': __props.accionEnProceso && __props.accionPedidoId === pedido.id,
                }]),
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  }, null, -1)
                ]))], 2)),
                _cache[24] || (_cache[24] = _createTextVNode(" Listo ", -1))
              ], 8, _hoisted_69),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('descargar-pdf', pedido.id)),
                disabled: tablaBloqueada.value,
                class: "flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-amber-50 text-amber-800 rounded-lg hover:bg-amber-100 transition-colors font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              }, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                  })
                ], -1),
                _createTextVNode(" pdf ", -1)
              ]))], 8, _hoisted_70)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})